import styled from "styled-components"
import {Table as TableBase} from "react-bootstrap"

import {Para} from "@irati/ui/src/Labels"
import BaseButton from "@irati/ui/src/Button"
import CardBase from "@irati/ui/src/Layout/Card"
import LinkBase from "@irati/ui/src/Link"
import {DosisBold, LatoBold} from "@irati/ui/src/global/fonts"
import {perkbox} from "@irati/ui/src/global/colors"
import CircleContainerBase from "@irati/ui/src/CircledConnector"

export const BigLink = styled(LinkBase)`
  font-size: 18px;
`

export const CircleContainer = styled(CircleContainerBase)`
  margin-bottom: 30px;
`

export const SpacedDiv = styled.div`
  max-width: 700px;
`
export const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

export const SpacedPara = styled(Para)`
  line-height: 1.5em;
`

interface ButtonProps {
  margin?: string
}

export const Button = styled(BaseButton)<ButtonProps>`
  ${({margin}) => margin && `margin: ${margin};`}
`

export const Table = styled(TableBase)`
  margin-top: 30px;
`

export const Card = styled(CardBase)`
  border-radius: 10px;
  padding: 30px 15px;
  width: 49%;
  max-width: 350px;
  margin-right: 10px;
  text-align: center;
`

export const RelativeContainer = styled.div`
  position: relative;
`

export const IconWrapper = styled.div`
  cursor: pointer;
  margin-right: 15px;
`

interface LinkProps {
  lato: boolean,
  size: number
}
export const Link = styled(LinkBase)<LinkProps>`
  text-transform: none;
  font-size: ${({size}) => size || 18}px;
  color: ${perkbox.blue};
  ${({lato}) => lato ? LatoBold : DosisBold}
`
